'use strict';

exports.__esModule = true;
exports.updateCustomTags = updateCustomTags;

var _validateCustomTags = require('./validate-custom-tags');

var _parse = require('../../renderer/utils/parse');

function updateCustomTags(tags, customTags) {
  if ((0, _validateCustomTags.validateCustomTags)(customTags).isValid) {
    var parsedTags = (0, _parse.parse)(customTags).map(function (customTag) {
      customTag.custom = true;
      return customTag;
    });
    return tags.filter(function (tag) {
      return !tag.custom;
    }).concat(parsedTags);
  } else {
    return tags;
  }
}